import {Pipe, PipeTransform} from '@angular/core';
import {DataBatchTools} from '@selpia/shared/utils';
import {DataPoint} from '@selpia/shared/models';

@Pipe({standalone: true, name: 'selectDataPoint'})
export class SelectDataPointPipe implements PipeTransform {
  transform(
    value: DataPoint[],
    measureCode: string | undefined,
    periodCode: string | undefined,
    date: Date | undefined,
  ): DataPoint | undefined {
    if (!measureCode || !periodCode || !date) {
      return;
    }

    return DataBatchTools.getDataPointFor(value, {measureCode, periodCode, date});
  }
}
